// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/finding_legacy.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentQuote } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Comment } from "./comment_pb";
import { file_inventory_v1_comment } from "./comment_pb";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { Documentation } from "./documentation_pb";
import { file_inventory_v1_documentation } from "./documentation_pb";
import type { Implication } from "./implication_pb";
import { file_inventory_v1_implication } from "./implication_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/finding_legacy.proto.
 */
export const file_inventory_v1_finding_legacy: GenFile = /*@__PURE__*/
  fileDesc("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", [file_artifacts_v1_model, file_google_protobuf_timestamp, file_inventory_v1_comment, file_inventory_v1_company_summary, file_inventory_v1_documentation, file_inventory_v1_implication, file_inventory_v1_risk]);

/**
 * @generated from message inventory.v1.Finding
 */
export type Finding = Message<"inventory.v1.Finding"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * @generated from field: repeated string solution_ids = 3;
   */
  solutionIds: string[];

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 5;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: inventory.v1.FindingStatus status = 6;
   */
  status: FindingStatus;

  /**
   * @generated from field: repeated inventory.v1.Implication implications = 7;
   */
  implications: Implication[];

  /**
   * @generated from field: string assignee = 8;
   */
  assignee: string;

  /**
   * @generated from field: google.protobuf.Timestamp detection_time = 10;
   */
  detectionTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 11;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: bool visible = 12;
   */
  visible: boolean;

  /**
   * @generated from field: string subtitle = 13;
   */
  subtitle: string;

  /**
   * @generated from field: optional string control_scope_name = 14;
   */
  controlScopeName?: string;
};

/**
 * Describes the message inventory.v1.Finding.
 * Use `create(FindingSchema)` to create a new message.
 */
export const FindingSchema: GenMessage<Finding> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 0);

/**
 * @generated from message inventory.v1.GetFindingResponse
 */
export type GetFindingResponse = Message<"inventory.v1.GetFindingResponse"> & {
  /**
   * @generated from field: inventory.v1.Finding finding = 1;
   */
  finding?: Finding;

  /**
   * @generated from field: inventory.v1.Documentation documentation = 2;
   */
  documentation?: Documentation;

  /**
   * @generated from field: inventory.v1.CompanySummary company = 3;
   */
  company?: CompanySummary;

  /**
   * @generated from field: string markdown = 4;
   */
  markdown: string;

  /**
   * @generated from field: repeated string control_ids = 5;
   */
  controlIds: string[];

  /**
   * @generated from field: repeated artifacts.v1.DocumentQuote document_quotes = 6;
   */
  documentQuotes: DocumentQuote[];
};

/**
 * Describes the message inventory.v1.GetFindingResponse.
 * Use `create(GetFindingResponseSchema)` to create a new message.
 */
export const GetFindingResponseSchema: GenMessage<GetFindingResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 1);

/**
 * @generated from message inventory.v1.GetFindingTimelineResponse
 */
export type GetFindingTimelineResponse = Message<"inventory.v1.GetFindingTimelineResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.FindingTimelineItem items = 1;
   */
  items: FindingTimelineItem[];
};

/**
 * Describes the message inventory.v1.GetFindingTimelineResponse.
 * Use `create(GetFindingTimelineResponseSchema)` to create a new message.
 */
export const GetFindingTimelineResponseSchema: GenMessage<GetFindingTimelineResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 2);

/**
 * @generated from message inventory.v1.FindingTimelineItem
 */
export type FindingTimelineItem = Message<"inventory.v1.FindingTimelineItem"> & {
  /**
   * @generated from oneof inventory.v1.FindingTimelineItem.timeline_item
   */
  timelineItem: {
    /**
     * @generated from field: inventory.v1.FindingChange change = 1;
     */
    value: FindingChange;
    case: "change";
  } | {
    /**
     * @generated from field: inventory.v1.Comment comment = 2;
     */
    value: Comment;
    case: "comment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.FindingTimelineItem.
 * Use `create(FindingTimelineItemSchema)` to create a new message.
 */
export const FindingTimelineItemSchema: GenMessage<FindingTimelineItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 3);

/**
 * @generated from message inventory.v1.FindingChange
 */
export type FindingChange = Message<"inventory.v1.FindingChange"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: inventory.v1.FindingStatus prev_status = 2;
   */
  prevStatus: FindingStatus;

  /**
   * @generated from field: inventory.v1.FindingStatus new_status = 3;
   */
  newStatus: FindingStatus;

  /**
   * @generated from field: inventory.v1.RiskLevel prev_risk_level = 4;
   */
  prevRiskLevel: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel new_risk_level = 5;
   */
  newRiskLevel: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.Comment comment = 6;
   */
  comment?: Comment;

  /**
   * @generated from field: string user_id = 7;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.FindingChange.
 * Use `create(FindingChangeSchema)` to create a new message.
 */
export const FindingChangeSchema: GenMessage<FindingChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 4);

/**
 * FindingCountStat — kept for the legacy V1/V2/V3 export PDF, which displays
 * a findings-by-level distribution computed at render time from the snapshot.
 *
 * @generated from message inventory.v1.FindingCountStat
 */
export type FindingCountStat = Message<"inventory.v1.FindingCountStat"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 1;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message inventory.v1.FindingCountStat.
 * Use `create(FindingCountStatSchema)` to create a new message.
 */
export const FindingCountStatSchema: GenMessage<FindingCountStat> = /*@__PURE__*/
  messageDesc(file_inventory_v1_finding_legacy, 5);

/**
 * @generated from enum inventory.v1.FindingStatus
 */
export enum FindingStatus {
  /**
   * @generated from enum value: FINDING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FINDING_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: FINDING_STATUS_ONGOING = 2;
   */
  ONGOING = 2,

  /**
   * @generated from enum value: FINDING_STATUS_ACCEPTED = 3;
   */
  ACCEPTED = 3,

  /**
   * @generated from enum value: FINDING_STATUS_RESOLVED = 4;
   */
  RESOLVED = 4,

  /**
   * @generated from enum value: FINDING_STATUS_NOT_APPLICABLE = 5;
   */
  NOT_APPLICABLE = 5,
}

/**
 * Describes the enum inventory.v1.FindingStatus.
 */
export const FindingStatusSchema: GenEnum<FindingStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_finding_legacy, 0);

